<div fxLayout="column" fxLayoutGap="15px">
  <mat-card>
    <h3>Editar Usuário</h3>
    <form [formGroup]="formEditUser" autocomplete="off" (submit)="onSubmit()">
      <div fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email">
        </mat-form-field>
      </div>

      <div fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>Telefone</mat-label>
          <input
            mask="(00) 0000-0000||(00) 00000-0000"
            matInput
            type="tel"
            formControlName="mobile"
          >
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline">
          <mat-label>Nova senha</mat-label>
          <input matInput type="password" formControlName="password">
        </mat-form-field>
      </div>

      <div class="flex flex-col gap-1">
        <mat-slide-toggle color="primary" formControlName="can_see_all">Administrador</mat-slide-toggle>
        <mat-slide-toggle color="primary" formControlName="is_actived">Ativo</mat-slide-toggle>
      </div>

    </form>
  </mat-card>
  <mat-card *ngIf="_loading === false">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div fxLayout="column">
        <span class="business-name">Empresa</span>
        <span class="business-items">{{ business ? business.name : "SEM EMPRESA" }}</span>
        <span class="business-items">{{ business?.cnpj | mask:'CPF_CNPJ' }}</span>
      </div>
      <button mat-stroked-button color="accent" *ngIf="!changing" (click)="changeCompany()">
        <mat-icon>sync</mat-icon>Alterar
      </button>
      <button mat-stroked-button color="warn" *ngIf="changing" (click)="changeCompany()">
        <mat-icon>close</mat-icon>Cancelar
      </button>
    </div>

    <div fxLayoutAlign="start center" fxLayoutGap="10px" *ngIf="changing">
      <app-business-selection
        fxFlex
        (businessSelected)="businessSelected($event)"
      ></app-business-selection>
    </div>

  </mat-card>
  <div fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="onSubmit()">Atualizar</button>
  </div>
</div>
